// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#2475ff"};